import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Loading } from '../components/shared/loading';
import { useAuth } from './use-auth';

const FEDERATED_CALLBACK_TIMEOUT_MS = 10_000;

export function FederatedCallbackPage() {
    const { user, loading, error } = useAuth();
    const [settledAttempts, setSettledAttempts] = useState(0);
    const [timedOut, setTimedOut] = useState(false);

    useEffect(() => {
        if (!loading) {
            setSettledAttempts((n) => n + 1);
        }
    }, [loading]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimedOut(true);
        }, FEDERATED_CALLBACK_TIMEOUT_MS);
        return () => {
            clearTimeout(timer);
        };
    }, []);

    if (user) {
        return <Navigate to="/" replace />;
    }
    if (error) {
        return <Navigate to="/login?error=federated" replace />;
    }
    // First settled cycle is the mount-time loadUser (no session yet).
    // The second is the Hub-driven loadUser after Amplify completes the OAuth
    // code exchange. Redirecting earlier races the exchange and aborts it.
    if (settledAttempts >= 2 || timedOut) {
        return <Navigate to="/login" replace />;
    }
    return <Loading />;
}
